import { Component, Input } from "@angular/core";

@Component({
    selector: "se-about-org",
    template: `
        <p><strong>Mission:</strong> {{ mission }}</p>
        <img [src]="imageUrl" alt="Organization Image" class="org-image" style="max-width: 200px; height: auto;" />
    `,
    styles: [
        `
            .se-about-org h2 {
                margin-top: 0;
            }
        `,
    ],
})
export class SeAboutOrgComponent {
    @Input() mission: string;
    @Input() imageUrl: string;
}
